module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ../node_modules/axios/index.js
// module id = 284
// module chunks = 0